module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.76/css/toolsmenu.css"